import { createRequiredAction } from '@eluve/frontend-machine-utils';

import { AppointmentTask } from './types';

export const scheduleBackgroundTaskAction =
  createRequiredAction<AppointmentTask>('schedule background task');

export type ScheduleBackgroundTaskAction = typeof scheduleBackgroundTaskAction;
